import { UserMinusIcon, UserPlusIcon } from "lucide-react";

import { ActivityEventRow, EventIconCircle, UserName } from "./ActivityEventRow";

import { useGetUser } from "@/hooks/queries/useGetUser";
import { activityTypography } from "@/lib/constants";
import { CandidacyOwnerChangeAction, type CandidacyOwnerChange } from "@/types";

export const OwnerChangeEvent = ({
  candidateFullName,
  currentUserId,
  ownerChange,
}: {
  candidateFullName: string;
  currentUserId: number;
  ownerChange: CandidacyOwnerChange;
}) => {
  /* Database CRUD Operations */
  // Read
  const { data: ownerUser } = useGetUser({ userId: ownerChange.userId });
  const { data: performedByUser } = useGetUser({
    userId: ownerChange.performedByUserId,
  });

  /* Helpers */
  const isAdded = ownerChange.action === CandidacyOwnerChangeAction.ADDED;
  const isSelfAction = ownerChange.userId === ownerChange.performedByUserId;
  const candidateEmphasis = (
    <span className={activityTypography.emphasis}>{candidateFullName}</span>
  );

  /* Render */
  const renderSentence = () => {
    if (isSelfAction) {
      return (
        <>
          <UserName currentUserId={currentUserId} user={performedByUser} />{" "}
          {isAdded ? "assigned" : "unassigned"}{" "}
          {currentUserId === ownerChange.userId ? "yourself" : "themselves"}{" "}
          {isAdded ? "to" : "from"} {candidateEmphasis}
        </>
      );
    }

    const ownerFullName = ownerUser
      ? `${ownerUser.firstName} ${ownerUser.lastName}`
      : "a staffer";
    return (
      <>
        <UserName currentUserId={currentUserId} user={performedByUser} />{" "}
        {isAdded ? "assigned" : "unassigned"}{" "}
        <span className={activityTypography.emphasis}>{ownerFullName}</span>{" "}
        {isAdded ? "to" : "from"} {candidateEmphasis}
      </>
    );
  };

  const render = () => {
    return (
      <ActivityEventRow
        createdAt={ownerChange.createdAt}
        icon={
          <EventIconCircle
            className={isAdded ? "bg-primary-900" : "bg-slate-400"}
          >
            {isAdded ? (
              <UserPlusIcon className="h-3 w-3 text-white" />
            ) : (
              <UserMinusIcon className="h-3 w-3 text-white" />
            )}
          </EventIconCircle>
        }
      >
        {renderSentence()}
      </ActivityEventRow>
    );
  };

  return render();
};
